import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const buildQueryBooster = (props, data) => {
  const {
    recencyBoostProperty
  } = props;
  if (!recencyBoostProperty || !recencyBoostProperty.length) return data;
  const {
    rawQueryStringified = ''
  } = data;
  const parsedRawQuery = JSON.parse(rawQueryStringified);
  const {
    function_score: {
      query,
      functions = []
    } = {}
  } = parsedRawQuery;
  const boostedPropsFunctios = recencyBoostProperty.map(propToBoost => ({
    gauss: {
      [propToBoost]: {
        origin: 'now',
        scale: '30d',
        offset: '7d',
        decay: 0.5
      }
    }
  }));
  const updatedData = {
    function_score: {
      query: functions.length ? query : parsedRawQuery,
      functions: [...functions, ...boostedPropsFunctios],
      boost_mode: 'multiply'
    }
  };
  return _objectSpread(_objectSpread({}, data), {}, {
    rawQueryStringified: JSON.stringify(updatedData)
  });
};
export default buildQueryBooster;
//# sourceMappingURL=build-query-booster.js.map